/* eslint-disable max-lines */
/* eslint-disable max-statements */
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Card from '@taglivros/oef_componentes/build/components/card'
import Toast from '@taglivros/oef_componentes/build/components/toast'

import React, { Fragment, useEffect, useState } from 'react'
import CardAdicionar from '../../../components/CardAdicionar'
import EnderecoForm from '../../../components/EnderecoForm/EnderecoForm'
import ConteudoWrapper from '../../../components/ConteudoWrapper/ConteudoWrapper'
import CardEnderecoEntrega from '../components/CardEnderecoEntrega/CardEnderecoEntrega'
import ModalConfirmacao from '../../../components/ModalConfirmacao/ModalConfirmacao'
import ModalConfirmaEndereco from '../components/ModalConfirmaEndereco/ModalConfirmaEndereco'
import InlineLoader from '../../../components/InlineLoader/InlineLoader'
import { useGlobal } from '../../../contexts/GlobalContext'
import { useEndereco } from '../../../contexts/EnderecoContext'
import { getInformacoesModalidadePorAssinatura, getAssinaturaDoAssociadoPorModalidade } from '../../../utils/helpers/helpersAssinatura'
import BreadcrumbGlobal from '../../../components/BreadcrumbGlobal/BreadcrumbGlobal'
import { isArray, isEmptyObject } from '../../../utils/helpers/helpers'
import { MessageCombo } from '../../../components/MessageCombo'
import useEnvioUnico from '../../../hooks/useEnvioUnico'

const Titulo = styled.h1`
  ${StyleGuide.tipografia.titulo1};
  margin: 25px 0 10px 0;

  @media ( max-width: ${StyleGuide.mediaQuery.mobile} ) {
    margin: 15px 0 0 0;
  }
`

const Entrega = () => {
  const [ frete, setFrete ] = useState( '' )
  const [ toast, setToast ] = useState( {} )
  const [ idAssinatura, setIdAssinatura ] = useState()
  const [ enderecoExclusao, setEnderecoExclusao ] = useState()
  const [ modalExclusao, setModalExclusao ] = useState( false )
  const [ openFormulario, setOpenFormulario ] = useState( false )
  const [ modalConfirmacao, setModalConfirmacao ] = useState( false )
  const [ modalidadeEndereco, setModalidadeEndereco ] = useState()
  const { dadosGlobaisAssociado, modalidadeURL } = useGlobal()
  const [ isEnvioUnico, loadinEnvioUnico ] = useEnvioUnico()
  const [ statusAssinatura, setStatusAssinatura ] = useState( '' )

  const {
    deleteEndereco,
    editEndereco,
    enderecoAdicionado,
    enderecoEditado,
    enderecoExcluido,
    enderecosCadastrados,
    enderecoSelecionado,
    enderecoVigente,
    getEnderecos,
    postEndereco,
    postEnderecoVigente,
    setEnderecoAdicionado,
    setEnderecoEditado,
    setEnderecoExcluido,
    setEnderecoSelecionado,
    loadingRequisicaoNovoEndereco
  } = useEndereco()

  useEffect( () => {
    if ( modalidadeURL ) {
      setModalidadeEndereco( getInformacoesModalidadePorAssinatura( modalidadeURL ) )
    }
  }, [ modalidadeURL ] )

  useEffect( () => {
    if ( !isEmptyObject( enderecoSelecionado ) ) {
      setModalConfirmacao( true )
    }

    if ( enderecoSelecionado && enderecoSelecionado.frete ) {
      let modalidadeFrete

      if ( isArray( enderecoSelecionado.frete ) && !isEmptyObject( modalidadeEndereco ) ) {
        modalidadeFrete = enderecoSelecionado.frete.find( item => item.idModalidade === modalidadeEndereco.id ).preco
      } else {
        const modalidadeEnderecoId = modalidadeEndereco.id
        modalidadeFrete = enderecoSelecionado.frete[ modalidadeEnderecoId ]
      }

      if ( modalidadeFrete ) {
        setFrete( modalidadeFrete )
      }
    }
  }, [ enderecoAdicionado, enderecoSelecionado, modalidadeEndereco ] )

  useEffect( () => {
    if ( dadosGlobaisAssociado ) {
      const assinaturaObtida = getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidadeURL )

      if ( assinaturaObtida ) {
        setStatusAssinatura( assinaturaObtida.status )
        setIdAssinatura( assinaturaObtida.id )
      }
    }
  }, [ dadosGlobaisAssociado ] )

  useEffect( () => {
    if ( idAssinatura ) {
      getEnderecos( idAssinatura )
    }
  }, [ idAssinatura ] )

  useEffect( () => {
    setToast( {
      'funcao': () => setEnderecoAdicionado( false ),
      'message': 'Endereço adicionado com sucesso!',
      'show': enderecoAdicionado
    } )
  }, [ enderecoAdicionado ] )

  useEffect( () => {
    setToast( {
      'funcao': () => setEnderecoEditado( false ),
      'message': 'Endereço editado com sucesso!',
      'show': enderecoEditado
    } )
  }, [ enderecoEditado ] )

  useEffect( () => {
    setToast( {
      'funcao': () => setEnderecoExcluido( false ),
      'message': 'Endereço excluído com sucesso!',
      'show': enderecoExcluido
    } )
  }, [ enderecoExcluido ] )

  function orderArrayByVigenciaFirst( array ) {
    const enderecoWithVigencia = array.filter( element => element.vigencia.assinaturas.length > 0 )
    enderecoWithVigencia.forEach( adress => {
      const index = array.indexOf( adress )
      const thisAdressHasIdAssinatura = adress.vigencia.assinaturas.find( item => item === idAssinatura )
      array.splice( index, 1 )
      if ( thisAdressHasIdAssinatura ) {
        array.splice( 0, 0, adress )
      } else {
        array.splice( 1, 0, adress )
      }
    } )
    return array
  }

  const ofereceEnderecoVigente = itemSelecionado => {
    setEnderecoSelecionado( itemSelecionado )
    setModalConfirmacao( true )
  }

  const onCancelarVigente = () => {
    setModalConfirmacao( false )
    setEnderecoSelecionado( null )
    if ( idAssinatura ) {
      getEnderecos( idAssinatura )
    }
  }

  const onConfirmarVigente = () => {
    setModalConfirmacao( false )
    postEnderecoVigente( enderecoSelecionado.id, idAssinatura )
  }

  const confirmaExclusao = enderecoId => {
    setEnderecoExclusao( enderecoId )
    setModalExclusao( true )
  }

  const adicionarEndereco = enderecoRetornado => {
    postEndereco( enderecoRetornado, idAssinatura )
    setOpenFormulario( false )
  }

  const editarEndereco = enderecoRetornado => {
    editEndereco( enderecoRetornado, idAssinatura )
  }

  const excluirEndereco = idEndereco => {
    setModalExclusao( false )
    deleteEndereco( idEndereco, idAssinatura )
  }

  const isVigente = item => {
    if ( idAssinatura ) {
      return item.vigencia.assinaturas.includes( idAssinatura )
    }
  }

  const isPendente = item => {
    if ( idAssinatura ) {
      return item.vigencia.pendente.includes( idAssinatura )
    }
  }

  if ( loadingRequisicaoNovoEndereco || loadinEnvioUnico ) {
    return <InlineLoader isCenter />
  }

  const renderAddEndereço = () => {
    return openFormulario ? (
      <Card className="card">
        <EnderecoForm
          endereco={ enderecoSelecionado ? enderecoSelecionado : {} }
          onCancelar={ () => setOpenFormulario( false ) }
          onConfirmar={ enderecoRetornado => adicionarEndereco( enderecoRetornado ) }
        />
      </Card>
    ) : (
      <CardAdicionar
        data-testid="adicionar-endereco"
        margin={ StyleGuide.isMobile() ? '30px 0 0' : '0 0 25px' }
        onClick={ () => setOpenFormulario( true ) }
        titulo="Adicionar novo endereço"
      />
    )
  }


  return (
    <Fragment>
      {modalExclusao ?
        <ModalConfirmacao
          acaoPrimariaTitulo="Confirmar"
          acaoSecundariaTitulo="Cancelar"
          onClickAcaoPrimaria={ () => excluirEndereco( enderecoExclusao ) }
          onClickAcaoSecundaria={ () => setModalExclusao( false ) }
          titulo="Você tem certeza que deseja excluir este endereço?"
        /> : null}

      {modalConfirmacao ?
        <ModalConfirmaEndereco
          enderecoAdicionado={ enderecoSelecionado }
          enderecoVigente={ enderecoVigente }
          frete={ frete }
          onCancelar={ () => onCancelarVigente() }
          onConfirmar={ () => onConfirmarVigente( enderecoSelecionado.id ) }
          open={ modalConfirmacao }
        /> : null}

      <BreadcrumbGlobal
        exactPath="entrega"
        nomeAlternativo="Entrega"
        padding="20px 0 0"
      />

      <Titulo>Dados de Entrega</Titulo>

      <Toast
        close={ toast.funcao ? toast.funcao : () => {} }
        fullWidth={ true }
        message={ toast.message ? toast.message : '' }
        show={ toast.show }
        type="success"
      />

      {isEnvioUnico ?
        <MessageCombo
          maxWidth="862px"
          text="Você faz parte do envio unificado da TAG. Seu endereço vigente precisa ser o mesmo nas duas assinaturas (Inéditos e Curadoria). Caso eles sejam diferentes, você passa a receber seus kits separadamente."
        /> : null}

      {enderecosCadastrados.length ? (
        <ConteudoWrapper>
          {orderArrayByVigenciaFirst( enderecosCadastrados ).map( item => {
            return (
              <CardEnderecoEntrega
                ativo={ isPendente( item ) || isVigente( item ) }
                botaoEditar
                botaoExcluir={ !isVigente( item ) || statusAssinatura === 'Cancelado' }
                botaoVerMais={ false }
                endereco={ item }
                hasHover
                isEnderecoVigente={ isVigente( item ) }
                key={ item.id }
                onClickCard={ () => !openFormulario &&
                  !isVigente( item ) &&
                  ofereceEnderecoVigente( item ) }
                onConfirmar={ enderecoRetornado => editarEndereco( enderecoRetornado ) }
                onExcluir={ () => confirmaExclusao( item.id ) }
                showModalidadeTitulo={ isPendente( item ) || isVigente( item ) }
                tituloNovoEndereco={ isPendente( item ) }
              />
            )
          } )}

          {renderAddEndereço()}
        </ConteudoWrapper>
      ) : (
        <div>{renderAddEndereço()}</div>
      )}
    </Fragment>
  )
}

export default Entrega
